export const ru = {
  'meta.title': 'gAz — grit And zeal',

  'nav.home': 'Главная',
  'nav.news': 'Новости',
  'nav.roster': 'Состав клана',
  'nav.achievements': 'Достижения',
  'nav.media': 'Медиа',
  'nav.join': 'Заявка на вступление',
  'nav.contacts': 'Контакты',
  'nav.history': 'История клана',
  'nav.admin': 'Админка',
  'nav.collapse': 'Свернуть меню',
  'nav.expand': 'Развернуть меню',
  'nav.menu': 'Меню',
  'nav.language': 'Язык',

  'common.loading': 'Загрузка архива…',
  'common.error': 'Не удалось загрузить данные.',
  'common.retry': 'Повторить',
  'common.empty': 'Записей пока нет.',
  'common.back': 'Назад',
  'common.readMore': 'Читать',
  'common.all': 'Все',
  'common.newest': 'Сначала новые',
  'common.oldest': 'Сначала старые',
  'common.open': 'Открыть',
  'common.close': 'Закрыть',
  'common.records': 'записей',
  'common.record': 'Запись',
  'common.section': 'Раздел',

  'footer.tagline': 'Клан StarCraft II. Стойкость и рвение.',
  'footer.sections': 'Разделы',
  'footer.community': 'Сообщество',
  'footer.adminContact': 'Связь с администрацией',
  'footer.adminContactText': 'Пишите офицерам клана в Discord или в Telegram.',
  'footer.rights': 'Все права защищены. StarCraft — торговая марка Blizzard Entertainment.',

  'footer.madeBy': 'Сайт разработал',

  'home.kicker': 'StarCraft II · клан',
  'home.title': 'grit And zeal',
  'home.subtitle':
    'Команда, которая собирается ради игры, остаётся ради людей и возвращается ради следующих матчей.',
  'home.ctaMeet': 'Познакомиться с командой',
  'home.ctaJoin': 'Присоединиться',
  'home.aboutTitle': 'О команде',
  'home.about1':
    'grit And zeal — киберспортивная команда, объединённая общей игрой, соревновательным духом и желанием развиваться вместе.',
  'home.about2':
    'Мы играем, разбираем матчи, участвуем в турнирах, делимся опытом и создаём собственную историю. Для нас команда — это не просто список игроков, а люди, с которыми хочется возвращаться в игру.',
  'home.statRosters': 'составов',
  'home.statPlayers': 'игроков',
  'home.statResults': 'результатов в архиве',
  'home.latestNews': 'Последние записи',
  'home.allNews': 'Все новости',
  'home.rostersTitle': 'Составы',
  'home.allRosters': 'Весь состав',
  'home.achievementsTitle': 'Свежие результаты',
  'home.allAchievements': 'Все достижения',
  'home.joinTitle': 'Набор открыт',
  'home.joinText': 'Любой уровень, от бронзы до грандмастера. Главное — желание играть и расти вместе.',

  'news.title': 'Новости',
  'news.lead': 'Журнал текущих событий клана: матчи, турниры, объявления и интервью.',
  'news.cat.team': 'Новости команды',
  'news.cat.results': 'Результаты матчей',
  'news.cat.announcements': 'Объявления',
  'news.cat.tournaments': 'Турниры',
  'news.cat.interviews': 'Интервью',
  'news.related': 'Связанные публикации',
  'news.gallery': 'Галерея',
  'news.video': 'Видео',
  'news.links': 'Ссылки',
  'news.notFound': 'Публикация не найдена или снята с публикации.',
  'news.toList': 'Ко всем новостям',

  'roster.title': 'Состав клана',
  'roster.lead': 'Пять составов по уровню MMR. Нажмите на ник, чтобы открыть карточку игрока.',
  'roster.players': 'игрок|игрока|игроков',
  'roster.noPlayers': 'Состав формируется.',
  'roster.mmrFrom': '{min}+ MMR',
  'roster.mmrTo': 'до {max} MMR',
  'roster.mmrRange': '{min}–{max} MMR',
  'roster.filter.from': 'от',
  'roster.filter.to': 'до',
  'roster.filter.reset': 'Сбросить фильтры',
  'roster.filter.found': 'Найдено',
  'roster.filter.none': 'Нет игроков под выбранные фильтры.',

  'player.race': 'Раса',
  'player.role': 'Роль',
  'player.pulse': 'SC2: Pulse',
  'player.openPulse': 'Профиль на SC2 Pulse',
  'player.mmr': 'MMR',
  'player.roster': 'Состав',
  'player.battleTag': 'BattleTag',
  'player.country': 'Страна',
  'player.notFound': 'Игрок не найден.',
  'player.toRoster': 'К составу клана',
  'player.card': 'Карточка игрока',
  'race.protoss': 'Протосс',
  'race.terran': 'Терран',
  'race.zerg': 'Зерг',
  'race.random': 'Рандом',
  'role.member': 'Участник',
  'role.officer': 'Офицер',
  'role.leader': 'Клан-лидер',

  'ach.title': 'Достижения',
  'ach.lead': 'Хронология побед и результатов. Архив хранится полностью — от первых турниров до последних.',
  'ach.event': 'Событие',
  'ach.date': 'Дата',
  'ach.mmr': 'MMR',
  'ach.place': 'Место',
  'ach.source': 'Результаты',
  'ach.vod': 'Запись',

  'media.title': 'Медиа',
  'media.lead': 'Библиотека записей и материалов: стримы, матчи, лучшие моменты, скриншоты и фото.',
  'media.type.stream': 'Записи стримов',
  'media.type.match': 'Видео матчей',
  'media.type.highlight': 'Лучшие моменты',
  'media.type.screenshot': 'Скриншоты',
  'media.type.photo': 'Фотографии',
  'media.search': 'Поиск по названию',
  'media.nothingFound': 'Ничего не найдено.',

  'join.kicker': 'Набор в клан',
  'join.title': 'Заявка на вступление в клан gAz',
  'join.text':
    'Мы всегда открыты к новым участникам. Заполни заявку, мы ознакомимся с ней и свяжемся с тобой через указанный способ связи.',
  'join.nickname': 'Игровой ник',
  'join.profile': 'Ссылка на игровой профиль',
  'join.profileHint': 'Battle.net, SC2 Pulse или RankedFTW',
  'join.mmr': 'MMR',
  'join.timezone': 'Часовой пояс',
  'join.contact': 'Discord или другой контакт',
  'join.contactHint': 'Ник в Discord, @telegram или ссылка',
  'join.comment': 'Дополнительный комментарий',
  'join.commentHint': 'Раса, опыт, чего ждёшь от клана',
  'join.submit': 'Отправить заявку',
  'join.sending': 'Отправка…',
  'join.successTitle': 'Заявка отправлена',
  'join.successText': 'Спасибо! Мы получили твою заявку и свяжемся с тобой через указанный контакт в ближайшее время.',
  'join.again': 'Отправить ещё одну',
  'join.rateLimited': 'Слишком много заявок с этого адреса. Попробуй позже.',
  'join.invalid': 'Проверь поля формы: {error}',
  'join.failed': 'Не удалось отправить заявку. Попробуй ещё раз или напиши нам в Discord.',
  'join.required': 'обязательное поле',
  'join.steps': 'Что дальше',
  'join.step1': 'Офицеры читают заявку',
  'join.step2': 'Связываемся с тобой в Discord / Telegram',
  'join.step3': 'Знакомство и распределение в состав по MMR',

  'contacts.title': 'Контакты',
  'contacts.lead': 'Где живёт клан: общение, стримы, видео и турниры.',
  'contacts.discord': 'Основной сервер клана: общение, тренировки, кастомки и войс.',
  'contacts.telegram': 'Канал с новостями и анонсами.',
  'contacts.twitch': 'Стримы клановых войн, турниров и внутренних ивентов.',
  'contacts.youtube': 'Записи стримов, разборы и лучшие моменты.',
  'contacts.challonge': 'Сетки наших турниров и внутренних соревнований.',
  'contacts.admin': 'Администрация',
  'contacts.adminText': 'По вопросам сотрудничества, турниров и клановых войн пишите офицерам клана в Discord.',

  'history.kicker': 'Хроника клана',
  'history.hint': 'Нажмите на экран или используйте стрелки',
  'history.s1.title': 'Зарождение',
  'history.s1.text':
    'Клан зародился в комьюнити StarCraft 2 как амбициозный проект игрока ModkoW. Название **gAz** расшифровывается как **«grit And zeal»** (что в переводе означает **«стойкость и рвение»**). Это название определило игровой характер команды: стойко принимать поражения на ладдере, учиться на ошибках и с рвением оттачивать билды.',
  'history.s2.title': 'Становление',
  'history.s2.text':
    'Перейдя от стадии идеи к практике, клан начал активно разрастаться и быстро преодолел отметку в **30+ постоянных участников**. Главным фактором этого этапа стало создание комфортной и нетоксичной атмосферы. Внутри gAz стерлись грани между рангами: игроки из алмаза и мастера начали регулярно проводить совместные тренировки, тренировочные кастомные матчи и разбирать реплеи новичков. Клан перестал быть просто тегом в игре.',
  'history.s3.title': 'Киберспорт',
  'history.s3.text':
    'Со временем gAz заявили о себе на соревновательной сцене комьюнити. Команда начала регулярно участвовать в **клановых войнах** против других известных коллективов. Более того, для повышения планки мастерства руководство gAz стало организовывать эксклюзивные **мастер-классы с профессиональными игроками**, выводя уровень своих игроков на новый уровень.',
  'history.s4.title': 'Текущий статус',
  'history.s4.text':
    'Сегодня клан gAz прочно закрепил за собой статус **одного из самых активных, открытых и дружелюбных молодых сообществ по StarCraft 2**. Они участвуют на всевозможных турнирах и событиях. Клан живёт активной жизнью в Discord и Telegram, постоянно проводит собственные внутренние ивенты и продолжает открытый набор игроков, готовых развиваться под знаменем grit And zeal.',
  'history.restart': 'С начала',
  'history.join': 'Вступить в клан',
  'history.prev': 'Назад',
  'history.next': 'Дальше',
  'history.chapter': 'Глава',

  'live.title': 'Сейчас в эфире',
  'live.clan': 'Канал клана',
  'live.watch': 'Смотреть на Twitch',
  'live.viewers': 'зритель|зрителя|зрителей',

  'admin.title': 'Управление архивом',
  'admin.lead': 'Добавление и редактирование новостей, достижений, медиа и составов.',
  'admin.email': 'Email',
  'admin.password': 'Пароль',
  'admin.signIn': 'Войти',
  'admin.signingIn': 'Вход…',
  'admin.logout': 'Выйти',
  'admin.badCredentials': 'Неверный email или пароль.',
  'admin.notAdmin': 'У этого аккаунта нет прав администратора.',
  'admin.tab.news': 'Новости',
  'admin.tab.achievements': 'Достижения',
  'admin.tab.media': 'Медиа',
  'admin.tab.rosters': 'Составы',
  'admin.tab.players': 'Игроки',
  'admin.tab.applications': 'Заявки',
  'admin.new': 'Добавить',
  'admin.edit': 'Изменить',
  'admin.delete': 'Удалить',
  'admin.save': 'Сохранить',
  'admin.cancel': 'Отмена',
  'admin.saved': 'Сохранено',
  'admin.deleted': 'Удалено',
  'admin.confirmDelete': 'Удалить запись «{name}»?',
  'admin.upload': 'Загрузить',
  'admin.uploading': 'Загрузка…',
  'admin.draft': 'черновик',
  'admin.addLink': 'Добавить ссылку',
  'admin.status.new': 'Новая',
  'admin.status.accepted': 'Принята',
  'admin.status.rejected': 'Отклонена',
  'admin.status.archived': 'Архив',
  'admin.noRoster': '— без состава —',
} as const;
